if (!('onhashchange' in window)) {
  console.warn("The browser doesn't support the hashchange event!, Router would not work");
}

const hashChangePolyfill = () => {
  let lastURL = document.URL;
  window.addEventListener('hashchange', event => {
    Object.defineProperty(event, 'oldURL', {
      enumerable: true,
      configurable: true,
      value: lastURL,
    });

    Object.defineProperty(event, 'newURL', {
      enumerable: true,
      configurable: true,
      value: document.URL,
    });

    lastURL = document.URL;
  });
};

export default hashChangePolyfill();
